// extracted by mini-css-extract-plugin
export default {"mainBody":"App_mainBody__kCH37","title":"App_title__szBWH","ignoreAll":"App_ignoreAll__o5Dwb"};